var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row.wave)?_c('div',[_vm._v(_vm._s(_vm.getWaveDisplayName(_vm.row.wave)))]):_c('div',[_vm._v("-")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5253ce18","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderTable/components/tdWave.vue
// module id = 9B7k
// module chunks = 0